webpackJsonp([274779505120957],{

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'url'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'url()'
	      ),
	      ' method is responsible for constructing the final URL used for API calls.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Behavior'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default behavior is to append the model\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'urlRoot'
	      ),
	      '. For example, if the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'urlRoot'
	      ),
	      ' is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/tweets'
	      ),
	      ', then the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'url()'
	      ),
	      ' will be one of the following:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'If the model has no ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'id'
	        ),
	        ', then ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'url()'
	        ),
	        ' will return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'http://localhost:1337/tweets'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'If the model has an ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'id'
	        ),
	        ' of ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '1'
	        ),
	        ', then ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'url()'
	        ),
	        ' will return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'http://localhost:1337/tweets/1'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      url: function() {\n        const base =\n          _.result(this, \'urlRoot\') ||\n          _.result(this.collection, \'url\') ||\n          urlError();\n\n        if (this.isNew()) {\n          return base;\n        }\n\n        const id = this.get(this.idAttribute);\n        return base.replace(/[^\\/]$/, \'$&/\') + encodeURIComponent(id);\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'One use for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'url()'
	      ),
	      ' is to construct nested URLs. You can read more about that in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'initialize()'
	      ),
	      ' documentation ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/models/properties/initialize/' },
	        'here'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-url-js-cd82fb5f29215086a3c1.js